"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabLoaderWrapper = exports.StyledTab = exports.Title = exports.StyledContainer = void 0;
const styles_1 = require("@mui/material/styles");
const Box_1 = __importDefault(require("@mui/material/Box"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const Tab_1 = __importDefault(require("@mui/material/Tab"));
exports.StyledContainer = (0, styles_1.styled)(Box_1.default)(({ theme }) => ({
    backgroundImage: theme.palette.gradient.blue,
    display: "flex",
    width: "100%",
    height: "176px",
    flexWrap: "wrap",
    borderBottom: `2px solid ${theme.palette.institutional.braskemYellow}`,
    alignItems: "flex-end",
}));
exports.Title = (0, styles_1.styled)(Typography_1.default)(({ theme }) => ({
    color: theme.palette.grayScale.white,
    width: "100%",
    fontWeight: "bold",
}));
exports.StyledTab = (0, styles_1.styled)(Tab_1.default)(({ theme }) => ({
    color: theme.palette.grayScale.white,
    "&.Mui-selected": {
        color: theme.palette.institutional.braskemYellow
    },
    "&.MuiButtonBase-root": {
        padding: "12px"
    }
}));
exports.TabLoaderWrapper = (0, styles_1.styled)("div")({
    display: "flex",
    justifyContent: "space-between",
    flex: "1 1 auto",
    maxWidth: "380px",
    margin: "0px 80px 12px",
    position: "relative",
    whiteSpace: "nowrap"
});
